import {createAction} from '@reduxjs/toolkit'
import BigNumber from "bignumber.js";
import {CurrencyState} from "./reducer";




export const upDataCurrency = createAction<CurrencyState>('CurrentCoin/upDataBalance');

